module.exports = __webpack_public_path__ + "img/map-satelite.85c4d6ec.png";